import { createRequestTypes } from '../utils';

export const PRODUCT_PHRASE_LIST_FOR_PRODUCT = createRequestTypes('productPhrase/PRODUCT_PHRASE_LIST_FOR_PRODUCT');

export const SAVE_PRODUCT_PHRASE = createRequestTypes('productPhrase/SAVE_PRODUCT_PHRASE');
export const DELETE_PRODUCT_PHRASE = createRequestTypes('productPhrase/DELETE_PRODUCT_PHRASE');
export const COPY_PRODUCT_PHRASE_FROM_PRODUCT = createRequestTypes('productPhrase/COPY_PRODUCT_PHRASE_FROM_PRODUCT');
